// extracted by mini-css-extract-plugin
module.exports = {"newsCarouselBlock":"newsCarouselBlock_newsCarouselBlock__w9mMP"};